import { render, staticRenderFns } from "./YkIvrCallDetails.vue?vue&type=template&id=5d308264&"
import script from "./YkIvrCallDetails.vue?vue&type=script&lang=js&"
export * from "./YkIvrCallDetails.vue?vue&type=script&lang=js&"
import style0 from "./YkIvrCallDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports